import { ButtonBase, styled } from '@mui/material';
import { DragEvent, ReactNode, useCallback } from 'react';

type OWDropZoneProps = {
    children?: ReactNode;
    onChange: (newFile: string) => void;
    onDragEnter: () => unknown;
    onDragLeave: () => unknown;
    accept?: string;
};

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const OWDropZone = ({ children, onChange, onDragEnter, onDragLeave, accept }: OWDropZoneProps) => {
    const handleDrag = useCallback(
        (e: DragEvent<HTMLLabelElement>) => {
            e.preventDefault();
            const fileReader = new FileReader();
            switch (e.type) {
                case 'dragenter':
                    onDragEnter();
                    break;
                case 'dragover':
                    onDragEnter();
                    break;
                case 'dragleave':
                    onDragLeave();
                    break;
                case 'drop':
                    onDragLeave();
                    fileReader.onload = (e) => onChange(e.target?.result as string);
                    fileReader.readAsDataURL(e.dataTransfer.files[0]);
                    break;
            }
        },
        [onChange, onDragEnter, onDragLeave],
    );

    return (
        <ButtonBase
            data-testid="ow-drop-zone"
            component="label"
            onDragEnter={handleDrag}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrag}
        >
            {children}
            <VisuallyHiddenInput
                onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                        const fileReader = new FileReader();
                        fileReader.onload = (e) => onChange(e.target?.result as string);
                        fileReader.readAsDataURL(e.target.files[0]);
                    }
                }}
                type="file"
                accept={accept}
            />
        </ButtonBase>
    );
};

export default OWDropZone;
